import { render, staticRenderFns } from "./ChannelNotesSelect.vue?vue&type=template&id=4344640e"
import script from "./ChannelNotesSelect.vue?vue&type=script&lang=js"
export * from "./ChannelNotesSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports